export default __webpack_public_path__ + "static/media/YTInactive.ddfe31da.svg";